const currentYear = new Date().getFullYear();

export const metaData = {
  ownerShip: [
    {
      name: 'self',
      label: 'Self',
    },
    {
      name: 'other',
      label: 'Other',
    },
  ],
  businessAddress: [
    {
      name: 'same',
      label: 'Use the same address as on return',
    },
    {
      name: 'new',
      label: 'New Address',
    },
  ],
  fiscalPeriod: [
    {
      name: 'next',
      label: `Jan 1, ${currentYear - 1} to Dec 31, ${currentYear - 1}`,
    },
    {
      id: 'current',
      label: `Rest of ${currentYear - 1} year`,
    },
  ],
  firstLast: [
    {
      name: 'neither',
      label: 'Neither',
    },
    {
      name: 'first',
      label: 'First',
    },
    {
      name: 'last',
      label: 'Last',
    },
  ],
  vehicleCCAClass: [
    { id: '1', name: '1' },
    { id: '3', name: '3' },
    { id: '6', name: '6' },
    { id: '8', name: '8' },
    { id: '10', name: '10' },
    { id: '10.1', name: '10.1' },
    { id: '12', name: '12' },
    { id: '13', name: '13' },
    { id: '14', name: '14' },
    { id: '14.1', name: '14.1' },
    { id: '16', name: '16' },
    { id: '17', name: '17' },
    { id: '29', name: '29' },
    { id: '38', name: '38' },
    { id: '43', name: '43' },
    { id: '43.1', name: '43.1' },
    { id: '43.2', name: '43.2' },
    { id: '46', name: '46' },
    { id: '50', name: '50' },
    { id: '53', name: '53' },
    { id: '54', name: '54' },
    { id: '55', name: '55' },
  ],
  vehicleKilometers: [
    {
      name: 'travelled-for-business',
      label: 'Kilometers travelled for business',
    },
    {
      name: 'travelled-total',
      label: 'Total kilometers travelled',
    },
  ],
  vehicleExpenses: [
    {
      name: 'fuel-cost',
      label: 'Fuel Cost',
    },
    {
      name: 'maintenance-repair',
      label: 'Maintenance and repairs for the year',
    },
    {
      name: 'insurance-premium',
      label: 'Insurance premiums',
    },
    {
      name: 'supplementary-business-insurance',
      label: 'Supplementary business insurance',
    },
    {
      name: 'licence-and-registration',
      label: 'Licence and registration',
    },
    {
      name: 'interest-expenses-passenger-vehicle',
      label: 'Interest expenses - passenger vehicle',
    },
    {
      name: 'interest-expenses-other-than-passenger-vehicle',
      label: 'Interest expenses - other than passenger vehicle',
    },
    {
      name: 'rental-fees',
      label: 'Rental fees',
    },
    {
      name: 'parking-fees',
      label: 'Parking fees',
    },
    {
      name: 'other-expenses',
      label: 'Other expenses',
    },
  ],
  homeSituation: [
    {
      name: 'regular-case',
      label: 'Regular case - the 50% limit applies',
    },
    {
      name: 'special-situation',
      label: 'Special situation - the 50% limit does not apply',
    },
  ],
  homeOffExp: [
    {
      name: 'heat',
      label: 'Heat',
    },
    {
      name: 'electricity',
      label: 'Electricity',
    },
    {
      name: 'insurance',
      label: 'Insurance',
    },
    {
      name: 'maintenance-repair',
      label: 'Maintenance and Repair',
    },
  ],
  defaultOwnerShip: 'Sole proprietorship',
};

export const relationShipMetaData = [
  {
    name: 'father',
    label: 'Father',
  },
  {
    name: 'mother',
    label: 'Mother',
  },
  {
    name: 'child',
    label: 'Child',
  },
];

export const PaymentTypes = [
  {
    name: 'N/A',
    id: 0,
  },
  {
    name: 'Rent',
    id: 1,
  },
  {
    name: 'Property Tax',
    id: 2,
  },
  {
    name: 'Home Energy Costs on a Reserve',
    id: 3,
  },
  {
    name: 'Accommodation in Long-Term Care',
    id: 4,
  },
];
